import { alertActions } from '../_actions'
import { lookupConstants } from '../_constants'
import { sectorService, exchangeService, industryService } from '../_services'

export const lookupActions = {
  lookupData,
  lookupSector,
  lookupIndustry
}
function lookupSector() {
  return (dispatch, getState) => {
    sectorService.getSector()
      .then(
        sector => {
          console.log(sector)
          dispatch(lookupSectorRequestOnly(sector))
        },
        error => {
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
}
function lookupIndustry(){
  return (dispatch, getState) => {
    industryService.getIndustry()
      .then(
        industry => {
          console.log(industry)
          dispatch(lookupIndustryRequest(industry))
        },
        error => {
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
}
function lookupData(force) {
  return (dispatch, getState) => {
    console.log(getState())
    const sector = getState().lookup.sector
    const industry = getState().lookup.industry
    const exchange = getState().lookup.exchange
    //const company = getState().lookup.company

    if (sector.length < 1 || (force && force === 'force')) {
      sectorService.getSector()
        .then(
          sector => {
            console.log(sector)
            dispatch(lookupSectorRequest(sector))
          },
          error => {
            dispatch(alertActions.error(error.toString()))
          }
        )
    }
    if (industry.length < 1 || (force && force === 'force')) {
      industryService.getIndustry()
        .then(
          industry => {
            console.log(industry)
            dispatch(lookupIndustryRequest(industry))
          },
          error => {
            dispatch(alertActions.error(error.toString()))
          }
        )
    }
    if (exchange.length < 1 || (force && force === 'force')) {
      exchangeService.getExchange()
        .then(
          exchange => {
            console.log(exchange)
            dispatch(lookupExchangeRequest(exchange))
            dispatch(lookupLoadedAll(exchange))
          },
          error => {
            dispatch(alertActions.error(error.toString()))
          }
        )
    }
  }
}

// function lookupCompanyRequest(company) {
//   return { type: lookupConstants.FETCH_COMPANY, company }
// }
// function lookupRequest(company) {
//   return { type: lookupConstants.LOOKUP_REQUEST, company }
// }
// function lookupRequestEnd(response) {
//   return { type: lookupConstants.LOOKUP_REQUEST_END, response }
// }
function lookupSectorRequest(sector) {
  return { type: lookupConstants.FETCH_SECTORS, sector, isLoadedAll: true }
}
function lookupSectorRequestOnly(sector) {
  return { type: lookupConstants.FETCH_SECTORS_ONLY, sector, isLoadedAll: true }
}
// function lookupUserRequest(users) {
//   return { type: lookupConstants.FETCH_USERS, users,isLoadedAll:true }
// }
function lookupExchangeRequest(exchange) {
  return { type: lookupConstants.FETCH_EXCHANGE, exchange, isLoadedAll: false }
}
function lookupIndustryRequest(industry) {
  return { type: lookupConstants.FETCH_INDUSTRY, industry, isLoadedAll: false }
}
function lookupLoadedAll() {
  return { type: lookupConstants.LOADED_ALL, isLoadedAll: true }
}
